import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useFacilityGroupSize_facility$key } from "./__generated__/useFacilityGroupSize_facility.graphql";

export const useFacilityGroupSize = (
  facilityRef: useFacilityGroupSize_facility$key | null
) => {
  const facility = useFragment(useFacilityGroupSizeFragmentString, facilityRef);

  const minGroupSize = facility?.minMaxGroupSize?.min || 1;
  const maxGroupSize = facility?.minMaxGroupSize?.max || 10;

  return {
    min: minGroupSize,
    max: maxGroupSize,
  };
};

const useFacilityGroupSizeFragmentString = graphql`
  fragment useFacilityGroupSize_facility on Facility
  @argumentDefinitions(
    bookingType: { type: "BookingType", defaultValue: STANDARD }
  ) {
    minMaxGroupSize(bookingType: $bookingType) {
      min
      max
    }
  }
`;
